import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeCreateQuoteRateResults } from './normalize';

export const fetchCreatedQuoteRateResults = createProvider(api.fetchCreateQuoteRateResults)
  .andThen((res) => normalizeCreateQuoteRateResults(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch cached quote rate results aborted');
    } else {
      console.error('Fetch cached quote rate results failed:', error);
    }
    throw error;
  });
